import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/office365-hero.webp")